module.exports = __webpack_public_path__ + "static/media/search.3f4a1d2c.svg";